'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { Tooltip } from '~/components/primitives';
import { useIsDesktop } from '~/components/primitives/hooks/useIsDesktop';

/**
 * A tooltip that only exists where hovering does.
 *
 * On touch there is no hover, so these opened on tap — swallowing the tap, covering the thing
 * the user was reaching for, and needing a second tap elsewhere to dismiss. Anything the
 * tooltip says must therefore also be readable without it; this only removes a control that
 * cannot work, it does not hide information.
 */
export const HoverTooltip: React.FC<ComponentProps<typeof Tooltip>> = props => {
  const $ = _c(3);
  const t0 = useIsDesktop() && props.enabled !== false;
  let t1;
  if ($[0] !== props || $[1] !== t0) {
    t1 = <Tooltip {...props} enabled={t0} />;
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};